// extracted by mini-css-extract-plugin
export default {"addclass":"TeacherDashboard_addclass__+mC5E","classes":"TeacherDashboard_classes__SQgZG","qrResult":"TeacherDashboard_qrResult__a6STD","qrButton":"TeacherDashboard_qrButton__42oJD"};